export default "__VITE_ASSET__573cf72f__"